// Services grid cards (used by AIMLServiceCards section)
const aiMlServicesData = [
  {
    title: "Custom AI Development",
    description:
      "Our custom AI development delivers precisely engineered solutions that address your unique business challenges, driving innovation and competitive advantage through tailored artificial intelligence.",
    bullets: [
      "Industry‑Specific Solutions",
      "Future‑Proof Architecture",
      "Seamless Enterprise Integration",
      "Breakthrough Innovation",
    ],
    minHeight: 420,
    accent: "#F48428",
  },
  {
    title: "AI Consulting and Strategy",
    description:
      "Our strategic AI consulting transforms your business vision into actionable intelligence roadmaps, helping you navigate the modern AI landscape with expert guidance to maximize ROI and secure sustainable competitive advantages.",
    bullets: [
      "AI Readiness Assessment",
      "Strategic Implementation Planning",
      "Investment Optimization",
      "Market Differentiation",
    ],
    minHeight: 420,
    accent: "#F48428",
  },
  {
    title: "AI‑Powered Automation",
    description:
      "Our intelligent automation solutions transform your business operations by leveraging cutting‑edge AI to handle complex tasks with unprecedented speed and accuracy, liberating your human talent for higher‑value strategic work.",
    bullets: [
      "End‑to‑End Process Transformation",
      "Adaptive Workflow Intelligence",
      "Self‑Correcting Systems",
      "Dramatic ROI Improvement",
    ],
    minHeight: 420,
    accent: "#F48428",
  },
  {
    title: "Machine Learning Solutions",
    description:
      "Our advanced machine learning solutions harness sophisticated algorithms to extract actionable insights from your data ecosystem, enabling predictive capabilities that transform decision‑making and create new business opportunities.",
    bullets: [
      "Advanced Predictive Modeling",
      "Deep Pattern Recognition",
      "Hyper‑Personalization Engines",
      "Autonomous Learning Systems",
    ],
    minHeight: 420,
    accent: "#F48428",
  },
  {
    title: "Natural Language Processing (NLP)",
    description:
      "Our sophisticated NLP solutions break down the barriers between humans and machines, enabling your systems to understand contextual nuances, analyze sentiment with precision, and engage in conversational interfaces that transform customer experiences.",
    bullets: [
      "Contextual Understanding",
      "Emotion & Intent Analysis",
      "Multilingual Processing",
      "Conversational AI Systems",
    ],
    minHeight: 420,
    accent: "#F48428",
  },
  {
    title: "AI‑driven Business Intelligence",
    description:
      "Our AI‑powered business intelligence platforms transform raw data into strategic assets, delivering real‑time insights through intuitive visualizations and predictive analytics that empower decisive action and drive measurable business outcomes.",
    bullets: [
      "Interactive Visual Analytics",
      "Dynamic Real‑time Dashboards",
      "Prescriptive Intelligence",
      "Actionable Strategic Insights",
    ],
    minHeight: 420,
    accent: "#F48428",
  },
  {
    title: "Personalized Customer Experiences",
    description:
      "Our AI‑driven personalization engines create uniquely tailored customer journeys that adapt in real‑time to individual behaviors and preferences, fostering deeper engagement, loyalty, and conversion through genuinely meaningful interactions.",
    bullets: [
      "Precision Customer Modeling",
      "Real‑time Behavior Analytics",
      "Predictive Journey Orchestration",
      "Dynamic Experience Adaptation",
    ],
    minHeight: 420,
    accent: "#F48428",
  },
  {
    title: "Risk Management and Fraud Detection",
    description:
      "Our advanced AI security solutions provide proactive protection through sophisticated modeling, identifying potential threats before they materialize while ensuring regulatory compliance and robust system integrity.",
    bullets: [
      "Preemptive Threat Detection",
      "Advanced Risk Modeling",
      "Automated Compliance Systems",
      "Multi‑layered Security Framework",
    ],
    minHeight: 420,
    accent: "#F48428",
  },
  {
    title: "Operational Efficiency & Resource Optimization",
    description:
      "Our intelligent optimization solutions revolutionize operational efficiency through AI‑driven resource allocation, predictive maintenance, and autonomous process refinement, delivering significant cost reductions while maximizing productivity and quality.",
    bullets: [
      "Intelligent Process Automation",
      "Dynamic Resource Allocation",
      "Predictive Performance Optimization",
      "Transformative Cost Reduction",
    ],
    minHeight: 420,
    accent: "#F48428",
  },
];

// Expertise showcase cards
export const aiMlExpertiseCards = [
  {
    key: "deep-learning",
    image: "/assets/img/ai/genai-1.webp",
    title: "Deep Learning",
    desc: "We develop custom LLM‑based solutions — from chatbots and copilots to content generators and document summarizers.",
    useCases: [
      "RAG‑based chatbots",
      "Document Q&A",
      "AI assistants & copilots",
      "Image & code generation",
    ],
    industries: ["LegalTech", "EdTech", "Travel", "Construction", "Healthcare"],
    logos: ["OpenAI", "LangChain", "Vector", "Pinecone"],
  },
  {
    key: "data-science",
    image: "/assets/img/ai/genai-2.webp",
    title: "Data Science",
    desc: "We design and train neural networks for computer vision, speech, NLP, and structured data tasks.",
    useCases: [
      "Object detection & tracking",
      "OCR & document parsing",
      "Natural Language Processing",
      "Voice analysis & generation",
    ],
    industries: ["Automotive", "EdTech", "Manufacturing", "Healthcare"],
    logos: ["PyTorch", "TensorFlow", "ONNX", "YOLO"],
  },
  {
    key: "generative-ai",
    image: "/assets/img/ai/genai-3.webp",
    title: "Generative AI",
    desc: "We help businesses unlock actionable insights from structured and unstructured data — using ML, analytics, forecasting, and visualization.",
    useCases: [
      "Predictive modeling",
      "Time series forecasting",
      "Churn & segmentation analysis",
      "Data dashboards",
    ],
    industries: [
      "Retail",
      "HRTech",
      "SaaS",
      "Logistics",
      "Hospitality",
      "Travel",
    ],
    logos: ["XGBoost", "Jupyter", "HF"],
  },
];

// Process steps for mobile timeline
export const aiMlProcessMobileSteps = [
  {
    title: "Requirement Analysis",
    body: "Collaborate to define success metrics and map real‑world AI use cases across business workflows.",
  },
  {
    title: "Model Selection & Training",
    body: "Fine‑tune foundational models (e.g., GPT, LLaMA) or build custom architectures for vision, NLP, or tabular tasks.",
  },
  {
    title: "AI‑Enhanced UX/UI Design",
    body: "Design intuitive, AI‑powered interfaces with context‑aware recommendations, natural language input, and real‑time feedback loops.",
  },
  {
    title: "Backend AI Integration",
    body: "Deploy AI via secure APIs, containerized endpoints (Docker, KServe), and integrate with your tech stack (CRM, ERP, CMS).",
  },
  {
    title: "Testing & Optimization",
    body: "Stress‑test models for bias, latency, and drift — optimize for scalability, compliance, and continuous learning.",
  },
  {
    title: "Deployment & Scaling",
    body: "Implement auto‑scaling, monitoring (Prometheus, MLflow), and CI/CD pipelines to support long‑term AI operations.",
  },
];

// Tech stack tabs and data
export const aiMlTechTabs = [
  { id: "genai", label: "Generative AI Models" },
  { id: "nn", label: "Neural Networks" },
  { id: "dl", label: "Deep Learning (DL) Frameworks" },
  { id: "toolkits", label: "Modules/Toolkits" },
  { id: "mlops", label: "MLOps Tools" },
  { id: "libs", label: "Libraries" },
  { id: "vision", label: "Image Classification Models" },
];

export const aiMlTechItems = {
  genai: [
    { name: "GPT‑4 (OpenAI)", logo: "/assets/img/ai/Technology/GPT-4.webp" },
    { name: "Claude ", logo: "/assets/img/ai/Technology/Claude.webp" },
    { name: "Gemini 2.0 ", logo: "/assets/img/ai/Technology/Gemini 2.0.webp" },
    { name: "DeepSeek ", logo: "/assets/img/ai/Technology/DeepSeek.webp" },
    {
      name: "LLaMA 3 (Meta)",
      logo: "/assets/img/ai/Technology/LLaMA 3 (Meta).webp",
    },
    { name: "DALL·E (OpenAI)", logo: "/assets/img/ai/Technology/DALL E.webp" },
    { name: "Deep Art", logo: "/assets/img/ai/Technology/Deep Art.webp" },
    {
      name: "Stability AI",
      logo: "/assets/img/ai/Technology/Stability AI.webp",
    },
    { name: "Midjourney", logo: "/assets/img/ai/Technology/Midjourney.webp" },
    { name: "Flux", logo: "/assets/img/ai/Technology/Flux.webp" },
    { name: "Deepgram", logo: "/assets/img/ai/Technology/Deepgram.webp" },
  ],
  nn: [
    { name: "Transformer", logo: "/assets/img/ai/Technology/Transformer.webp" },
    { name: "CNN", logo: "/assets/img/ai/Technology/CNN.webp" },
    { name: "GAN", logo: "/assets/img/ai/Technology/GAN.webp" },
    { name: "RBM", logo: "/assets/img/ai/Technology/RBM.webp" },
    { name: "DBN", logo: "/assets/img/ai/Technology/DBN.webp" },
    { name: "DRLN", logo: "/assets/img/ai/Technology/DRLN.webp" },
    {
      name: "Autoencoders",
      logo: "/assets/img/ai/Technology/Autoencoders.webp",
    },
  ],
  dl: [
    { name: "TensorFlow", logo: "/assets/img/ai/Technology/TensorFlow.webp" },
    { name: "PyTorch", logo: "/assets/img/ai/Technology/PyTorch.webp" },
    { name: "Keras", logo: "/assets/img/ai/Technology/Keras.webp" },
    { name: "Caffe", logo: "/assets/img/ai/Technology/Caffe.webp" },
    { name: "MXNet", logo: "/assets/img/ai/Technology/MXNet.webp" },
    { name: "Theano", logo: "/assets/img/ai/Technology/Theano.webp" },
    { name: "Chainer", logo: "/assets/img/ai/Technology/Chainer.webp" },
    { name: "CNTK", logo: "/assets/img/ai/Technology/CNTK.webp" },
    { name: "Torch", logo: "/assets/img/ai/Technology/Torch.webp" },
    {
      name: "DeepLearning4j",
      logo: "/assets/img/ai/Technology/DeepLearning4j.webp",
    },
  ],
  toolkits: [
    {
      name: "Hugging Face",
      logo: "/assets/img/ai/Technology/Hugging Face.webp",
    },
    { name: "Meta AI", logo: "/assets/img/ai/Technology/Meta AI.webp" },
    {
      name: "DeepMind Sonnet",
      logo: "/assets/img/ai/Technology/DeepMind Sonnet.webp",
    },
    {
      name: "TensorFlow Probability",
      logo: "/assets/img/ai/Technology/TensorFlow Probability.webp",
    },
    { name: "Fastai", logo: "/assets/img/ai/Technology/Fastai.webp" },
    { name: "AllenNLP", logo: "/assets/img/ai/Technology/AllenNLP.webp" },
    { name: "NVIDIA NeMo", logo: "/assets/img/ai/Technology/NVIDIA NeMo.webp" },
  ],
  mlops: [
    { name: "MLflow", logo: "/assets/img/ai/Technology/MLflow.webp" },
    {
      name: "Weights & Biases",
      logo: "/assets/img/ai/Technology/Weights & Biases.webp",
    },
    { name: "Docker", logo: "/assets/img/ai/Technology/Docker.webp" },
    { name: "KServe", logo: "/assets/img/ai/Technology/KServe.webp" },
    { name: "SageMaker", logo: "/assets/img/ai/Technology/SageMaker.webp" },
    { name: "Azure ML", logo: "/assets/img/ai/Technology/Azure ML.webp" },
    {
      name: "Kubeflow Pipelines",
      logo: "/assets/img/ai/Technology/Kubeflow Pipelines.webp",
    },
    {
      name: "Evidently AI",
      logo: "/assets/img/ai/Technology/Evidently AL.webp",
    },
    {
      name: "Apache Airflow",
      logo: "/assets/img/ai/Technology/Apache Airflow.webp",
    },
    { name: "Prometheus", logo: "/assets/img/ai/Technology/Prometheus.webp" },
  ],
  libs: [
    {
      name: "Scikit-learn",
      logo: "/assets/img/ai/Technology/Scikit-learn.webp",
    },
    { name: "GPyTorch", logo: "/assets/img/ai/Technology/GPyTorch.webp" },
    { name: "Fastai", logo: "/assets/img/ai/Technology/Fastai.webp" },
  ],
  vision: [
    { name: "AlexNet", logo: "/assets/img/ai/Technology/AlexNet.webp" },
    { name: "DenseNet", logo: "/assets/img/ai/Technology/DenseNet.webp" },
    {
      name: "EfficientNet",
      logo: "/assets/img/ai/Technology/EfficientNet.webp",
    },
    {
      name: "Inception AI",
      logo: "/assets/img/ai/Technology/Inception AI.webp",
    },
    { name: "SqueezeNet", logo: "/assets/img/ai/Technology/SqueexeNet.webp" },
    { name: "Xception", logo: "/assets/img/ai/Technology/Xception.webp" },
    { name: "VGGNet", logo: "/assets/img/ai/Technology/VGGNet.webp" },
    { name: "MobileNet", logo: "/assets/img/ai/Technology/MobileNet.webp" },
    { name: "GoogLeNet", logo: "/assets/img/ai/Technology/GoogLeNet.webp" },
  ],
};

export default aiMlServicesData;
